import React, { Component, Fragment } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

import Logo from '../Logo/Logo'
import VideoCover from '../VideoCover/VideoCover'
import Map from '../Map/Map'
import SEO from '../SEO/SEO'

import styles from './HomePage.module.scss'

class HomePage extends Component {
	state = {isOnMap: null};
	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
	}
	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}
	handleScroll = () => {
		if (window.scrollY >= (this.refs.sectionMap.offsetTop - 350)) {
			this.setState({ isOnMap: true })
		} else {
			this.setState({ isOnMap: false })
		}	
	};
	render () {
		const {isOnMap} = this.state
		const {data} = this.props
		return (
			<Fragment>
				<SEO />
				<section className={styles.videoCoverContainer}>
					<div className={styles.copy}>
						<Logo fill="#fff" containerClassName={styles.logoContainer} />
						<p dangerouslySetInnerHTML={{ __html: data.markdownRemark.frontmatter.description }}></p>
						<AnchorLink href='#map' className={styles.goMapButton}>Desplázate para continuar</AnchorLink>
					</div>					
					<VideoCover src={data.markdownRemark.frontmatter.video.src.publicURL} />
				</section>
				<section id="map" className={styles.mapContainer} ref="sectionMap">
					{<Map isOnMap={isOnMap}
						  places={data.markdownRemark.frontmatter.map.places}
						  bgImage={data.markdownRemark.frontmatter.map.bgImage.childImageSharp}
					      bgPageImage={data.markdownRemark.frontmatter.map.bgPageImage.childImageSharp} />}
				</section>
			</Fragment>
		)
	}
}

export default HomePage


// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.js